<script lang="ts">
	import { afterNavigate } from '$app/navigation';
	import { onMount } from 'svelte';

	function setHeight(element: HTMLElement) {
		const fullHeaderHeight = element.parentElement
			? element.clientHeight +
				parseInt(getComputedStyle(element.parentElement).marginTop) +
				parseInt(getComputedStyle(element.parentElement).marginBottom)
			: element.clientHeight;

		document.body.style.setProperty('--header-height', `${fullHeaderHeight}px`);
	}

	function updateHeight(entries: ResizeObserverEntry[]) {
		const entry = entries?.[0];

		if (!entry) return;

		setHeight(entry.target as HTMLElement);
	}

	let observer: ResizeObserver;

	function listen() {
		if (observer) {
			observer.disconnect();
		}

		const header = document.getElementById('site-header');
		if (header) {
			setHeight(header);

			observer = new ResizeObserver(updateHeight);
			observer.observe(header);
		}
	}

	onMount(() => {
		listen();

		return () => observer?.disconnect();
	});

	afterNavigate(({ from }) => {
		if (from === null) return;

		listen();
	});
</script>
